import { render, staticRenderFns } from "./XieYi.vue?vue&type=template&id=022f41b8&scoped=true&"
import script from "./XieYi.vue?vue&type=script&lang=js&"
export * from "./XieYi.vue?vue&type=script&lang=js&"
import style0 from "./XieYi.vue?vue&type=style&index=0&id=022f41b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022f41b8",
  null
  
)

export default component.exports